<script>
export default {
  name: 'PlusIcon',
};
</script>

<template>
  <path
    d="M15.3337 7.99949C15.3337 8.30974 15.0798 8.56359 14.7696 8.56359H8.56443V14.7687C8.56443 15.0805 8.31213 15.3332 8.00033 15.3332C7.68852 15.3332 7.43622 15.079 7.43622 14.7687V8.56359H1.23109C0.919287 8.56359 0.666992 8.3115 0.666992 7.99984C0.666992 7.68923 0.919428 7.43538 1.23109 7.43538H7.43622V1.23025C7.43622 0.918446 7.68852 0.666504 8.00033 0.666504C8.31213 0.666504 8.56443 0.918587 8.56443 1.23025V7.43538H14.7696C15.0798 7.43538 15.3337 7.68923 15.3337 7.99949Z"
    fill="black"
  />
</template>
